import { render, staticRenderFns } from "./Spitexjobs.vue?vue&type=template&id=753bf90b&scoped=true"
import script from "./Spitexjobs.vue?vue&type=script&lang=js"
export * from "./Spitexjobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753bf90b",
  null
  
)

export default component.exports